module.exports = __webpack_public_path__ + "static/img/button11.98c4cbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/button11.png
// module id = Ds2M
// module chunks = 4